module.exports = __webpack_public_path__ + "img/xxnl-product2.a03e3463.png";